import * as React from "react";

import DynamicForm from "./Entities/DynamicForm";

import { addReview } from "../components/Firebase/firebase";
import Text from "./Entities/Text";
import Title from "./Entities/Title";
import { navigate } from "gatsby";
import { DataLayerInteracyionType, pushToDataLayer } from "../utils/gtm";

enum ReviewStatus {
  NULL,
  ACTIVE,
  THANKS,
}
const ReviewForm: React.FC<any> = ({ idWorld, auth, reviewSend }: any) => {
  const [state, setState] = React.useState<ReviewStatus>(ReviewStatus.NULL);

  const handleFormSubmit = (
    formId: string,
    formData: { [key: string]: any }
  ) => {
    const reviewDTO = {
      title: formData.title,
      comment: formData.comment,
      rating: formData.rating,
      date: new Date().getTime(),
    };
    addReview(idWorld, reviewDTO);
    setState(ReviewStatus.THANKS);
    reviewSend(reviewDTO);
    pushToDataLayer({
      event: "button-world-submitcomment",
      category: DataLayerInteracyionType.Button,
      label: "Submit Comment",
    });
  };

  React.useEffect(() => {
    if (auth !== null) {
      setState(ReviewStatus.NULL);
    }
  }, [auth]);

  const handleFormState = (status: ReviewStatus) => {
    let redirect:string = '';
    if (auth === null) {
      redirect = '/signIn'
    }

    if (auth !== null &&  auth.displayName === null) {
      redirect = '/profile'
    }
  
    pushToDataLayer({
      event: "button-world-addcomment",
      category: DataLayerInteracyionType.Button,
      label: `Submit Comment ${redirect}`,
    });

    if(redirect === ''){
      setState(status);
    }else{
      navigate(redirect);
    }
  };
  if (state == ReviewStatus.NULL) {
    return (
      <div className="text-center">
        <button
          id="add-comment"
          className="form-button action-button"
          onClick={() => handleFormState(ReviewStatus.ACTIVE)}
        >
          Add comment
        </button>
      </div>
    );
  }
  const showThanks = () => {
    return (
      <div>
        <Title
          value={{
            children: "Thanks for your review",
            type: "h2",
            className: "text-center text-secondary open-sans-normal",
          }}
        />
        <Text
          value={{
            injectedChildren: "Your review will be published soon",
            className: "text-secondary",
          }}
        />
      </div>
    );
  };
  return (
    <div className="text-center max-w-xs m-auto">
      {state == ReviewStatus.THANKS ? (
        showThanks()
      ) : (
        <DynamicForm
          value={{
            id: "review-form",
            fields: [
              {
                initialValue: "",
                id: "title",
                label: "Title",
                type: "text",
                placeholder: "Enter the title",
                className: "items-start text-sm text-secondary",
                inputClassName:
                  "w-[100%] border border-secondary rounded-md p-2 focus:outline-none",
                validate: [(value) => (!value ? "Title is required" : null)],
              },
              {
                initialValue: "",
                id: "comment",
                label: "Comment",
                type: "textarea",
                placeholder: "Enter the comment",
                className: "items-start text-sm text-secondary",
                inputClassName:
                  "w-[100%] h-[100px] border border-secondary rounded-md p-2 focus:outline-none",
                validate: [
                  (value) => (!value ? "Comment is required" : null),
                  (value) =>
                    value.length < 10
                      ? "Comment must be at least 10 letters"
                      : null,
                ],
              },
              {
                initialValue: "",
                id: "rating",
                label: "Rating",
                type: "stars",
                className: "justify-center text-xs text-secondary",
                validate: [(value) => (!value ? "Rating is required" : null)],
              },
            ],
            onSubmit: handleFormSubmit,
          }}
        />
      )}
    </div>
  );
};

export default ReviewForm;
